import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig } from '../../config/hotel-tours-list-page.config';
import { pluralize } from '../pipes/pluralize/pluralize';

@Component({
    selector: 'app-hotel-rating',
    templateUrl: environment.mobile ? './hotel-rating.component.mobile.html' : './hotel-rating.component.html',
    styleUrls: environment.mobile ? ['./hotel-rating.component.mobile.scss'] : ['./hotel-rating.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule]
})
export class HotelRatingComponent {
    @Input() rating: number;
    @Input() reviewsCount: number;
    @Input() type: string;
    messages: any = {};

    constructor(
        public cd: ChangeDetectorRef,
        @Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig,
    ) {
        this.messages = {
            'reviewsPlural': this.hotelToursPageConfig.translates.plurals.reviewsPlural
        };
    }

    get hotelRating() {
        if (Number(this.rating) === 10) {
            return '10';
        }

        return this.rating % 1 === 0 ? `${this.rating}.0` : this.rating;
    }

    get reviewsCountLabel() {
        if (environment.mobile) {
            return 'отз';
        }

        return pluralize(this.reviewsCount, this.messages.reviewsPlural);
    }

    get logo() {
        if (this.type === 'booking') {
            return '/x-assets/img/logo/logo-booking.svg';
        }

        return '/x-assets/img/logo/logo-ht-kz-blue-words.svg';
    }
}
